module.exports = __webpack_public_path__ + "img/header-weddingRingsPolar@2x.8589d96.webp";